import React from 'react';
import {Button, Checkbox, Form} from "semantic-ui-react";
import Info from "../../../components/Info.jsx";
import {formServicesArray} from "./utils";

const ExtraServicesPanel = ({
                                services = [],
                                form,
                                setServices,
                                onCalculate,
                                calculateLabel = 'Рассчитать услуги',
                                disabled = false,
                                isItemDisabled = null,
                                itemTooltipText = null
                            }) => {
    if (!services.length) {
        return null;
    }

    return (
        <div>
            {
                services.map(s => {
                    const itemDisabled = disabled || (isItemDisabled && isItemDisabled(s));
                    const field = (
                        <Form.Field key={s.value || s.name} className='result-step__item'>
                            <Checkbox
                                checked={formServicesArray(form).includes(s.value)}
                                disabled={itemDisabled}
                                onChange={(e, data) => !itemDisabled && setServices(s.value, data.checked)}
                            />
                            <div className='checkbox-label'>
                                {s.name}
                                {s.info && <Info
                                    name={s.name}
                                    text={s.info}
                                    position={'right'}
                                    offset={[10]}
                                />}
                            </div>
                        </Form.Field>
                    );
                    const tooltip = itemTooltipText ? itemTooltipText(s) : null;
                    return tooltip
                        ? <Info key={s.value || s.name} trigger={field} text={tooltip} position='right'/>
                        : field;
                })
            }
            {onCalculate && (
                <Button
                    type='button'
                    className='result-step__calc-services'
                    onClick={onCalculate}
                >
                    {calculateLabel}
                </Button>
            )}
        </div>
    );
};

export default ExtraServicesPanel;



// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/extraServicesPanel.jsx